import React from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import AcceptedReinstatementSidebar from './AcceptedReinstatementSidebar';
import DraftReinstatementSidebar from './DraftReinstatementSidebar';

interface Props {
	cancellationData: CancellationData;
}

const ReinstatementSidebar = (props: Props) => {
	const { cancellationData } = props;

	const { policy, selectedCancellation } = cancellationData;

	const { reinstatement } = selectedCancellation;

	if (!policy || !selectedCancellation || !reinstatement) {
		return <LargeCenterSpinner />;
	}

	if (reinstatement.state === 'draft') {
		return <DraftReinstatementSidebar />;
	} else {
		return <AcceptedReinstatementSidebar />;
	}
};

export default withCancellationContext<Props>(ReinstatementSidebar);
